import { render, staticRenderFns } from "./inputDate.vue?vue&type=template&id=dbaff446&scoped=true"
import script from "./inputDate.vue?vue&type=script&lang=js"
export * from "./inputDate.vue?vue&type=script&lang=js"
import style0 from "./inputDate.vue?vue&type=style&index=0&id=dbaff446&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbaff446",
  null
  
)

export default component.exports